/**
 * #4733: where `/` sends a sales role instead of the Overview, in one place
 * for both readers: HomeRoute (src/client/App.tsx) redirects by it, and the
 * page-to-API dark check (src/shared/rbac-page-api-dark.ts) leaves `/` out
 * of the sweep for a role it redirects, because the Overview never mounts for
 * that role and so never sends its requests.
 *
 * Its own module, not commercial-roles.ts: rbac.ts imports commercial-roles,
 * so isPathAllowed there would be an import cycle.
 */
import { commercialSalesHome } from "./commercial-roles";
import { isPathAllowed } from "./rbac";

/**
 * The sales landing for a user holding `roleIds` with `pages`, or null when
 * `/` behaves as usual. The page check keeps a stale or partial assignment
 * fail-closed: a sales role without the landing page stays on `/`.
 */
export function salesHomeLanding(roleIds: readonly string[], pages: readonly string[]): string | null {
  const home = commercialSalesHome(roleIds);
  return home && isPathAllowed(home, [...pages]) ? home : null;
}
